import ButtonPrimary from "componentsTemplate/Button/ButtonPrimary";
import Layout from "./layout";
import LayoutDashboard from "./layout/layout";
import TableContact from "components/table/tableContact";
import { useEffect, useState } from "react";
import FormDinamic from "./cadEditDinamic";
import PerfilService from "../../services/PerfilService";
import { Icon } from "@mui/material";
import { Search } from "@mui/icons-material";

const Dicas = () => {
  const [cadEditDinamic, setCadEditDinamic] = useState(false);
  const [user, setUser] = useState({} as any);

  const [dados, setDados] = useState(null);
  const [search, setSearch] = useState("");

  useEffect(() => {
    getUser();
  }, []);

  const getUser = async () => {
    await PerfilService.getUser()
      .then((response: any) => {
        setUser(response.data.user);
      })
      .catch((error: any) => {
        console.error(error);
      })
      .finally(() => {
        //setLoading(false); // end loading
      });
  };

  const acao = (dados: any) => {
    setDados(dados);
    setCadEditDinamic(true);
  };

  const acaoCadastrar = () => {
    setDados(null);
    setCadEditDinamic(true);
  };

  return (
    <Layout user={user}>
      <LayoutDashboard>
        <>
          <div>
            <TableContact
              coluna1="Postagem"
              coluna2="Usuário"
              coluna3="Tipo"
              coluna4="Data"
              rota="/posts/contact"
              acao={acao}
            />
          </div>
        </>
      </LayoutDashboard>
    </Layout>
  );
};

export default Dicas;
